var _linearGradient, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowSlidScroll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 64,
    viewBox: "0 0 61 60",
    width: 64,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 51.7914,
    x2: 8.57479,
    y1: 51.5926,
    y2: 8.84818
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#ff1b43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#be0000"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m37.202 0h-13.5468l-12.1714 5.90962-8.45813 10.70688-3.02567 13.3487 3.02567 13.3488 8.45813 10.7069 12.1714 5.9791h13.5468l12.1714-5.9791 8.4581-10.7069 3.0257-13.3488-3.0257-13.3487-8.4581-10.70688z",
    fill: "url(#a)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m39.3594 26.772 2.565 2.4782h-18.9244v1.0899h18.9244l-2.565 2.4782.799.7721 3.9259-3.7952-3.9259-3.7952z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.7248 32.8184-2.565-2.4783h18.9244v-1.0899h-18.9244l2.565-2.4782-.799-.772-3.9259 3.7952 3.9259 3.7952z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowSlidScroll);
export default __webpack_public_path__ + "static/media/arrow-slid-scroll.37f8a5b90a5a1626c89ea342ec52179c.svg";
export { ForwardRef as ReactComponent };